// extracted by mini-css-extract-plugin
module.exports = {"action":"SortableAllowanceItemsComponent__action--aPhwY","dragging":"SortableAllowanceItemsComponent__dragging--ORp6d"};